var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isDataLoaded
        ? [
            _vm.tagsLoaded
              ? _c("DropdownFilter", {
                  attrs: {
                    withoutLoading: "",
                    placeholder: "Select tag",
                    loading: _vm.$apollo.queries.tags.loading,
                    value: _vm.selectedTag,
                    multiple: true,
                    options: _vm.tags,
                    max: _vm.max,
                    customMultiStyleParent: _vm.getcontainerStyle,
                  },
                  on: { input: _vm.update },
                })
              : _c("InputPlaceholder"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }